(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-faq"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('marmor-faq-list')) return;
  customElements.define('marmor-faq-list', class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.events = new AbortController();
      const list = this.querySelector('.custom-faq-items-container');
      const items = [...list.querySelectorAll('.custom-faq-card')];
      const categories = [...list.querySelectorAll('.custom-faq-category')];
      const button = this.querySelector('[data-faq-toggle]');
      const limit = Math.max(1, Math.floor(Number(this.dataset.initialCount) || 4));
      const update = expanded => {
        items.forEach((item, index) => { item.hidden = !expanded && index >= limit; });
        categories.forEach(category => {
          let next = category.nextElementSibling, visible = false;
          while (next && !next.classList.contains('custom-faq-category')) {
            if (next.classList.contains('custom-faq-card') && !next.hidden) visible = true;
            next = next.nextElementSibling;
          }
          category.hidden = !visible;
        });
        if (button) {
          button.hidden = items.length <= limit;
          button.setAttribute('aria-expanded', String(expanded));
          button.textContent = expanded ? 'Show less' : 'View more questions';
        }
      };
      if (button) button.addEventListener('click', () => {
        const expanding = button.getAttribute('aria-expanded') !== 'true';
        update(expanding);
        if (!expanding) {
          button.focus({preventScroll:true});
          const rect = button.getBoundingClientRect();
          if (rect.top < 0 || rect.bottom > window.innerHeight) button.scrollIntoView({block:'nearest'});
        }
      }, {signal:this.events.signal});
      document.addEventListener('shopify:block:select', event => {
        if (this.contains(event.target) && event.target.hidden) update(true);
      }, {signal:this.events.signal});
      update(false);
    }
    disconnectedCallback() { this.events?.abort(); this.events = null; }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flexible-room-gallery"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('marmor-table-builder')) return;
  const savedSelections = new Map();
  customElements.define('marmor-table-builder', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const root = this;
      const $ = s => root.querySelector(s);
      const $$ = s => [...root.querySelectorAll(s)];
      const on = (target, type, fn) => target.addEventListener(type, fn, {signal: this.controller.signal});
      const state = {step: 1, category: '', style: null, marble: null, };
      const card = (kind, id) => $$(`[data-mar-${kind}]`).find(el => el.getAttribute(`data-mar-${kind}`) === id);
      const title = el => el?.querySelector('.mar-card__name')?.textContent.trim() || 'Not selected';
      const categoryName = () => $$('[data-mar-tab]').find(el => el.dataset.marTab === state.category)?.textContent.trim() || 'Not selected';
      const status = text => { $('[data-mar-status]').textContent = text; };
      function pressed(el, active) {
        el.classList.toggle('is-active', active);
        el.setAttribute('aria-pressed', String(active));
      }
      function image(target, source) {
        target.hidden = !source;
        if (source) { target.src = source.currentSrc || source.src; target.alt = source.alt || ''; }
        else target.removeAttribute('src');
      }
      function summary() {
        if (root.id) savedSelections.set(root.id, {...state});
        const style = card('style', state.style), marble = card('marble', state.marble);
        image($('[data-mar-summary="img"]'), selectedImage());
        $('[data-mar-summary="title"]').textContent = style ? title(style) : 'Choose your style to begin';
        $('[data-mar-summary="sub"]').textContent = marble ? title(marble) : 'Choose your marble';
      }
      function category(key) {
        state.category = key;
        $$('[data-mar-tab]').forEach(el => pressed(el, el.dataset.marTab === key));
        $$('[data-mar-style]').forEach(el => {
          el.hidden = el.dataset.marCategory !== key;
          if (el.hidden && el.dataset.marStyle === state.style) state.style = null;
          pressed(el, el.dataset.marStyle === state.style);
        });
        $('[data-mar-empty]').hidden = $$('[data-mar-style]').some(el => !el.hidden);
        summary();
      }
      function selectedImage() {
        const style = card('style', state.style), marble = card('marble', state.marble);
        const match = $$('[data-mar-finish]').find(el => el.dataset.styleKey === style?.dataset.styleKey && el.dataset.stoneKey === marble?.dataset.stoneKey);
        return match?.querySelector('img') || style?.querySelector('img');
      }
      function preview() {
        const style = card('style', state.style), source = selectedImage();
        image($('[data-mar-preview]'), source);
        $('[data-mar-preview-label]').textContent = source && source !== style?.querySelector('img') ? 'Preview of the selected style and stone combination' : 'Furniture reference — selected stone shown separately below';
      }
      function rows() {
        return [['Room', categoryName()], ['Furniture style', title(card('style', state.style))], ['Selected marble', title(card('marble', state.marble))]];
      }
      function review() {
        const style = card('style', state.style), marble = card('marble', state.marble);
        image($('[data-mar-review="styleImg"]'), selectedImage());
        image($('[data-mar-review="marbleImg"]'), marble?.querySelector('img'));
        $('[data-mar-review="marbleName"]').textContent = title(marble);
        $('[data-mar-review="marbleDesc"]').textContent = marble?.querySelector('.mar-card__desc')?.textContent || '';
        const list = $('[data-mar-review="list"]');
        list.replaceChildren();
        rows().forEach(([label, value]) => {
          const row = document.createElement('div'); row.className = 'mar-review__row';
          const key = document.createElement('span'), val = document.createElement('b');
          key.textContent = label; val.textContent = value; row.append(key, val); list.append(row);
        });
      }
      function validate(step) {
        if (step > 1 && !card('style', state.style)) { go(1, false); status('Please choose a furniture style first.'); return false; }
        if (step > 2 && !card('marble', state.marble)) { go(2, false); status('Please choose a marble first.'); return false; }

        return true;
      }
      function go(step, scroll = true) {
        step = Math.max(1, Math.min(3, step));
        if (step > state.step && !validate(step)) return;
        state.step = step; status('');
        $$('[data-mar-panel]').forEach(el => { const active = Number(el.dataset.marPanel) === step; el.hidden = !active; el.classList.toggle('mar-panel--on', active); });
        $$('[data-mar-step]').forEach(el => {
          el.classList.toggle('is-active', Number(el.dataset.marStep) === step);
          el.classList.toggle('is-done', Number(el.dataset.marStep) < step);
          if (Number(el.dataset.marStep) === step) el.setAttribute('aria-current', 'step'); else el.removeAttribute('aria-current');
        });
        $('[data-mar-nav="prev"]').hidden = step === 1;
        $('[data-mar-nav="next"]').hidden = step === 3;
        summary(); preview(); if (step === 3) review();
        if (scroll) {
          const heading = $(`[data-mar-panel="${step}"] h3`); heading.tabIndex = -1; heading.focus({preventScroll: true});
          root.scrollIntoView({block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
        }
      }
      function message(question = '') {
        const lines = ['Hello MARMOR, I would like a quotation for a custom piece.', ...rows().map(([key, val]) => `${key}: ${val}`)];
        for (const kind of ['style', 'marble']) { const img = card(kind, state[kind])?.querySelector('img'); if (img) lines.push(`${kind} reference: ${img.currentSrc || img.src}`); }
        if (question) lines.push('Question: ' + question);
        lines.push('Page: ' + location.origin + location.pathname);
        return lines.join('\n');
      }
      function send(kind, question = '') {
        if (!question && !validate(3)) return;
        const msg = message(question);
        if (kind === 'whatsapp') {
          const number = (root.dataset.whatsapp || '').replace(/\D/g, '');
          if (!number) { status('WhatsApp is not configured. Please use another contact method.'); return; }
          window.open('https://wa.me/' + number + '?text=' + encodeURIComponent(msg), '_blank', 'noopener,noreferrer');
        } else if (kind === 'email') {
          const email = root.dataset.email || '';
          if (!email) { status('Email is not configured. Please use another contact method.'); return; }
          location.href = 'mailto:' + encodeURIComponent(email) + '?subject=' + encodeURIComponent('Custom Marble Quote Request') + '&body=' + encodeURIComponent(msg);
        }
      }
      function chat(open) {
        $('[data-mar-chat]').hidden = !open;
        $('[data-mar-chat-toggle]').setAttribute('aria-expanded', String(open));
        if (open) $('[data-mar-question]').focus();
      }
      on(root, 'click', event => {
        const el = event.target.closest('button'); if (!el || !root.contains(el)) return;
        if (el.hasAttribute('data-mar-tab')) { status(''); category(el.dataset.marTab); }
        else if (el.hasAttribute('data-mar-style')) { state.style = el.dataset.marStyle; $$('[data-mar-style]').forEach(b => pressed(b, b === el)); summary(); preview(); status(''); }
        else if (el.hasAttribute('data-mar-marble')) { state.marble = el.dataset.marMarble; $$('[data-mar-marble]').forEach(b => pressed(b, b === el)); summary(); preview(); status(''); }
        else if (el.hasAttribute('data-mar-nav')) go(state.step + (el.dataset.marNav === 'next' ? 1 : -1));
        else if (el.hasAttribute('data-mar-step')) go(Number(el.dataset.marStep));
        else if (el.hasAttribute('data-mar-send')) send(el.dataset.marSend);
        else if (el.hasAttribute('data-mar-chat-toggle')) chat($('[data-mar-chat]').hidden);
        else if (el.hasAttribute('data-mar-chat-close')) chat(false);
        else if (el.hasAttribute('data-mar-question-send')) {
          const question = $('[data-mar-question]').value.trim();
          if (!question) { $('[data-mar-question]').focus(); return; }
          send(el.dataset.marQuestionSend, question);
        }
      });
      on(root, 'keydown', event => { if (event.key === 'Escape' && !$('[data-mar-chat]').hidden) { chat(false); $('[data-mar-chat-toggle]').focus(); } });
      on(document, 'shopify:block:select', event => {
        if (!root.contains(event.target)) return;
        const el = event.target.closest('[data-mar-style], [data-mar-marble], [data-mar-tab]');
        if (!el) return;
        if (el.hasAttribute('data-mar-tab')) { go(1, false); category(el.dataset.marTab); }
        if (el.hasAttribute('data-mar-style')) { go(1, false); category(el.dataset.marCategory); el.click(); }
        if (el.hasAttribute('data-mar-marble')) { state.step = 2; go(2, false); el.click(); }
      });
      const saved = root.id ? savedSelections.get(root.id) : null;
      if (saved) {
        state.style = card('style', saved.style) ? saved.style : null;
        state.marble = card('marble', saved.marble) ? saved.marble : null;
      }
      category(card('style', state.style)?.dataset.marCategory || $('[data-mar-tab]')?.dataset.marTab || '');
      $$('[data-mar-marble]').forEach(el => pressed(el, el.dataset.marMarble === state.marble));
      $$('[data-mar-marble], [data-mar-value]').forEach(el => el.setAttribute('aria-pressed', String(el.classList.contains('is-active'))));
      go(saved && state.style ? (state.marble ? Math.min(saved.step, 3) : Math.min(saved.step, 2)) : 1, false);
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => { const visible = entries[0].isIntersecting; $('.mar-bar').hidden = !visible; $('[data-mar-chat-toggle]').hidden = !visible; if (!visible) chat(false); });
        this.observer.observe(root);
      }
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; this.observer?.disconnect(); }
  });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
